import React from 'react'
import styled from 'styled-components'
import Logic from './logic'

import Form from 'containers/Form'
import EquipmentsSvg from 'containers/EquipmentsSvg'
import List from 'containers/EquipmentsListSimple'

import DivisionSelector from 'components/DivisionSelector'
import Section from 'components/Section'
import Loading from 'components/Loading'
import Error from 'components/Error'
import Tabs from 'components/Tabs'
import Modal from 'components/Modal'
import FixedWrapper from 'components/FixedWrapper'

import findIndex from 'lodash/findIndex'
import omit from 'lodash/omit'
import isEmpty from 'lodash/isEmpty'
import House from './house.svg'

/* eslint-disable camelcase */
@Logic
export default class Habitation extends Form {
  nextText = `PRÓXIMO passo`
  prevText = `Passo Anterior`

  state = {
    opened: [],
    responsiveOpen: false
  }

  componentDidMount () {
    // Scrols to top on component mount
    setTimeout(() => {
      const element = document.getElementById('anchor')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }, 100)
  }

  next = () => {
    const { valid, invalid } = this.isFormValid()
    const { setInvalid, setFinished } = this.actions
    const { router } = this.props

    if (valid) {
      setFinished({ habitationFinished: true })
      router.push('/faturacao')
    } else {
      setFinished({ habitationFinished: false })
      setInvalid(invalid)
    }
  }

  prev = () => {
    const { router } = this.props
    router.push('/')
  }

  /**
   * On click svg element select or de-select and element
   */
  onClickSvgElement = (id) => {
    const { setValues } = this.actions
    const { equipments, centralHeatingEquipments, sugestedEquipment } = this.props.data
    const { currentDivision } = this.props

    const equipmentsClone = [...equipments]
    const allEquipments = []

    if (equipments) {
      allEquipments.push(...equipmentsClone)
    }

    if (centralHeatingEquipments) {
      allEquipments.push(...centralHeatingEquipments)
    }

    const currentEquipments = this.props.values.equipments && [
      ...this.props.values.equipments
    ]

    // Found element in current? Remove it
    const indexFound = findIndex(currentEquipments, ({ svg_key, house_divisions }) => {
      return svg_key === id && house_divisions === currentDivision.id
    })

    if (indexFound !== -1) {
      currentEquipments.splice(indexFound, 1)
    } else {
      // Add new selected element
      // This gets the reference for some reason
      // Even using a clone it changed the referenced element
      // using {...} solved the issue
      let findElement = {...sugestedEquipment.find(({ svg_key }) => {
        return svg_key === id
      })}

      if (!isEmpty(findElement)) {
        findElement.house_divisions = currentDivision.id
        currentEquipments.push({ ...findElement })
      } else {
        findElement = {...allEquipments.find(({ svg_key }) => {
          return svg_key === id
        })}

        if (!isEmpty(findElement)) {
          findElement.house_divisions = currentDivision.id
          currentEquipments.push({ ...findElement })
        }
      }
    }

    // Set new values
    setValues({ equipments: currentEquipments })
  }

  setNewValuesToEquipment = (equipment) => {
    const { setValues } = this.actions
    const { currentDivision } = this.props
    const equipments = [ ...this.props.values.equipments ]
    const found = findIndex(equipments, ({ id, house_divisions }) => {
      return equipment.id === id && house_divisions === currentDivision.id
    })

    if (found !== -1) {
      // Remove equipment if quantity is zero
      if (!equipment.quantity) {
        equipments.splice(found, 1)
      } else {
        equipments[found] = equipment
      }

      setValues({ equipments })
    }
  }

  modalButtons = [
    {
      label: 'Fechar',
      primary: true,
      click: () => this.actions.closeStartModal()
    }
  ]

  onChangeEquipmentType = (equipment, newType) => {
    const { currentDivision } = this.props
    const { setValues } = this.actions

    const currentEquipments = this.props.values.equipments && [
      ...this.props.values.equipments
    ]

    // Reformat to equipment
    newType.id = newType.value
    newType.name = newType.label

    // Delete keys
    newType = omit(newType, ['label', 'value'])

    const foundEquipmentIndex = findIndex(currentEquipments, ({ id, house_divisions }) =>
      equipment.id === id &&
      house_divisions === currentDivision.id
    )

    if (foundEquipmentIndex !== -1) {
      const equipmentElement = currentEquipments[foundEquipmentIndex]

      // Get the old quantity and division adn set it to the new object
      newType.quantity = equipmentElement.quantity
      newType.house_divisions = equipmentElement.house_divisions

      currentEquipments[foundEquipmentIndex] = newType

      setValues({ equipments: currentEquipments })
    }
  }

  render () {
    const { setDivision, setCurrentTab } = this.actions
    const {
      loading,
      error,
      currentDivision,
      nextDivision,
      prevDivision,
      svg,
      currentTab,
      showStartModal,
      settings
    } = this.props

    const {
      hiddenSvgItems,
      equipments
    } = this.props.data
    if (error) {
      return <Error />
    }

    if (loading) {
      return <Loading />
    }

    const tabs = [
      'Equipamentos Adicionados',
      'Iluminação Adicionada'
    ]

    const currentEquipments = this.props.values.equipments && [
      ...this.props.values.equipments
    ]

    // Filter equipments to show in tabs
    let showingEquipments = this.props.values.equipments && [
      ...this.props.values.equipments
    ]

    let svgEquipments = currentEquipments &&
      currentEquipments.filter(({ house_divisions }) =>
        house_divisions === currentDivision.id
      )

    const iluminationType = 12

    showingEquipments = showingEquipments &&
      showingEquipments.filter(({ equipment_type, house_divisions }) => {
        const inDivision = house_divisions === currentDivision.id
        if (currentTab === 0) {
          return equipment_type.id !== iluminationType && inDivision
        } else {
          return equipment_type.id === iluminationType && inDivision
        }
      })

    return (
      <Wrapper>
        {this.renderNavbar()}
        <FixedWrapper>
          <SimpleSection
            title={`Minha Habitação`}
            subtitle={`Selecione e configure os equipamentos da sua habitação`}
          >
            <HabitationWrapper>
              <FirstCol>
                <DivisionSelector
                  currentDivision={currentDivision}
                  next={() => setDivision(nextDivision)}
                  prev={() => setDivision(prevDivision)}
                  prevName={prevDivision && prevDivision.name}
                  nextName={nextDivision && nextDivision.name}
                />

                {currentEquipments && svg &&
                <EquipmentsSvg
                  svg={svg}
                  currentEquipments={svgEquipments}
                  onClickElement={this.onClickSvgElement}
                  hiddenSvgItems={hiddenSvgItems}
                />
                }
              </FirstCol>

              <SecondCol className={this.state.responsiveOpen ? '' : 'closed'}>
                <EquipmentsList>
                  <EquipmentTab onClick={() => this.setState({ responsiveOpen: !this.state.responsiveOpen })} >Equipamentos</EquipmentTab>
                  <Tabs tabs={tabs} onClick={(index) => setCurrentTab(index)} currentIndex={currentTab} />
                  <List
                    allEquipments={equipments}
                    equipments={showingEquipments}
                    division={currentDivision}
                    onChange={(opened) => this.setNewValuesToEquipment(opened)}
                    onChangeEquipmentType={this.onChangeEquipmentType}
                  />
                </EquipmentsList>
              </SecondCol>
            </HabitationWrapper>
          </SimpleSection>
          {showStartModal && !settings.isFromProfile &&
          <HabitationModal
            toggle={showStartModal}
            title={`Simulador Simples`}
            buttons={this.modalButtons}
            onClick={this.actions.closeStartModal}
          >
            <Image src={House} />
            <Title>2. Minha Habitação</Title>
            <Text>
              <DisclaimerText>
                <ListBall />Foram adicionados equipamentos padrão/iluminação com base nas suas respostas.<br />
              </DisclaimerText>
              <DisclaimerText>
                <ListBall />Pode adicionar ou remover equipamentos/iluminação clicando na ilustração à esquerda.<br />
              </DisclaimerText>
              <DisclaimerText>
                <ListBall />Pode também detalhá-los na barra localizada à direita do seu ecrã.<br />
              </DisclaimerText>
              <DisclaimerTitle>
                Se pretender pode saltar para o passo seguinte.
              </DisclaimerTitle>
            </Text>
          </HabitationModal>}
        </FixedWrapper>
        {this.renderButtons()}
      </Wrapper>
    )
  }
}

const ListBall = styled.div`
width: 10px;
height: 10px;
background: linear-gradient(270deg,#006736 0%,#93C13E 100%);
display: inline-block;
border-radius: 50%;
margin-right: 10px;
`

const DisclaimerText = styled.span`
  display: block;
  margin-bottom: 20px;
  color: #222;

  @media (max-width: 860px) {
    margin-bottom: 8px;
    line-height: 16px;
  }
`

const Wrapper = styled.div`
  min-height: calc(100% - 60px);
  flex-direction: column;
  display: flex;
  flex: 1;
  user-select: none;
`

const FirstCol = styled.div`
  display: inline-block;
  padding-right: 80px;
  width: calc(100% - 280px);

  @media(max-width: 1280px) {
    width: 100%;
    padding-right: 20px;
    padding-left: 20px;
    box-sizing: border-box;
  }
`

const SecondCol = styled.div`
  width: 280px;
  box-shadow: inset 1px 0 0 0 #EFEFEF;
  transition: right 0.2s ease-out;

  ${({ className }) => className.includes('close') && `
  right: -280px !important;
  `
  }

  @media(max-width: 1280px) {
    position: absolute;
    top: 15%;
    right: 0;
    background-color: #fff;
    box-shadow: inset 1px 1px 0 0 #EFEFEF;
    border-bottom: 1px solid #EFEFEF;
    min-height: 300px;
  }
`

const EquipmentTab = styled.div`
  position: absolute;
  left: -82px;
  background: linear-gradient(270deg,#006736 0%,#93C13E 100%);
  color: #fff;
  padding: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: 600;
  transform: rotate(-90deg);
  top: 100px;
  display: none;

  @media(max-width: 1280px) {
    display: block;
  }
`

const HabitationWrapper = styled.div`
  display: flex;
  margin-top: 65px;
  position: relative;
`

const EquipmentsList = styled.div`
  width: 100%;
  padding: 0 10px;
`

const Text = styled.div`
  display: block;
  color: #010101;
  font-size: 16px;
  line-height: 24px;
  width: 80%;
  margin: 20px auto;
  text-align: left;
  margin-bottom: 60px;

  @media (max-width: 800px) {
    font-size: 13px;
    margin: 8px 0 8px 0;
    width: 100%;
  }
`

const Title = styled.div`
  color: #010101;
  font-size: 20px;
  font-weight: bold;
  line-height: 28px;
  text-align: center;
`
const Image = styled.img`
  width: 64px;
  display: block;
  margin: 20px auto;
  margin-top: 60px;
  margin-bottom: 40px;

  @media screen and (max-width: 800px) {
    margin-top: 18px;
    margin-bottom: 18px;
    width: 42px;
  }
`

const DisclaimerTitle = styled.span`
  display: block;
  font-weight: bold;
  margin-bottom: 20px;
  color: #93C13E;

  @media (max-width: 860px) {
    margin-bottom: 8px;
  }
`

const HabitationModal = styled(Modal)`
  @media screen and (max-width: 765px) {
    width: 100vw;


    > div:last-child > div {
      min-width: auto;
      left: auto;
    }
  }

`

const SimpleSection = styled(Section)`
    height: 100%;
    background-color: #fff!important;
`



// WEBPACK FOOTER //
// ./src/containers/SimpleHabitation/index.js